var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVendorShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16504,
    y: 0.98999,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#F5FBEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16504,
    y: 0.98999,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.165 20.6567C24.6143 20.6567 25.79 21.8325 25.79 23.2817C25.79 24.7583 24.6143 25.9067 23.165 25.9067C21.6885 25.9067 20.54 24.7583 20.54 23.2817V23.3091C20.54 23.0903 20.54 22.8989 20.5947 22.7349L17.7783 20.9849C17.3408 21.3403 16.7666 21.5317 16.165 21.5317C14.6885 21.5317 13.54 20.3833 13.54 18.9067C13.54 17.4575 14.6885 16.2817 16.165 16.2817C16.7666 16.2817 17.3408 16.5005 17.7783 16.856L20.5947 15.106C20.54 14.9419 20.54 14.7505 20.54 14.5317C20.54 13.0825 21.6885 11.9067 23.165 11.9067C24.6143 11.9067 25.79 13.0825 25.79 14.5317C25.79 16.0083 24.6143 17.1567 23.165 17.1567C22.5361 17.1567 21.9619 16.9653 21.5244 16.6099L18.708 18.3599C18.7627 18.5239 18.7627 18.7153 18.7627 18.9067C18.7627 19.1255 18.7627 19.3169 18.708 19.481L21.5244 21.231C21.9619 20.8755 22.5361 20.6567 23.165 20.6567Z",
    fill: "#3A6D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorShareIcon);
export default __webpack_public_path__ + "static/media/vendor-share-icon.d47bba1976b9b41bf90192d6a3250f4f.svg";
export { ForwardRef as ReactComponent };